import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps } from 'react-admin';
import { TrainingMenuList } from './TrainingMenuList';
import { TrainingMenuDatagrid } from './TrainingMenuDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { TrainingMenu } from './TrainingMenu';

export * from './TrainingMenu';
export * from './TrainingMenuCreate';
export * from './TrainingMenuDatagrid';
export * from './TrainingMenuEdit';
export * from './TrainingMenuList';
export * from './TrainingMenuShow';

const TrainingMenusBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'note', header: 'Note' },
	{ key: 'menuUrl', header: 'Menu URL' },
	{ key: 'type', header: 'Type' },
	{ key: 'fromBMR', header: 'From BMR' },
	{ key: 'toBMR', header: 'To BMR' }
];

export const TrainingMenusData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: TrainingMenu) => entity;

	const trainingMenusFilter = [
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('תכניות אימונים', exportFields, exportDataMapper)}
				{...props}
				filters={trainingMenusFilter}
				bulkActionButtons={<TrainingMenusBulkActionButtons/>}
				title="TRAINING_MENUS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <TrainingMenuList/> : <TrainingMenuDatagrid/>}
			</List>
		</Fragment>
	);
};
